module.exports = __webpack_public_path__ + "img/868-c3716a.png";